import script from "./FeatureFlagsTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeatureFlagsTab.vue?vue&type=script&setup=true&lang=ts"

import "./FeatureFlagsTab.vue?vue&type=style&index=0&id=a5508daa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5508daa"]])

export default __exports__